


















































































































































































































































































































































































































































































































import { Component, Vue, Prop, PropSync, Ref, Watch } from 'vue-property-decorator';
import { IRules, sValidation } from '@/components/UI/Form/ValidationModule';
import { validateRequired, validateType } from '@/components/UI/Form/Validations';
import { CURRENT_UNIT } from '@/queries/Application';
import { GQL_currentUnit_currentUnit } from '@/queries/__generated__/currentUnit';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_PaycheckLineCalculationTypeEnum, GQL_MainPaycheckLineTemplateSave, GQL_AltinnIncomeDescriptionEnum, GQL_AltinnFordelEnum } from '@/queries/global';
import { newMainPaycheckLineTemplateObject, convertToMainPaycheckLineTemplateSave } from '@/app/MainPaycheckLineTemplate';
import { generateUID, WithUID } from '@/utils/utils';
import { GQL_currentUnitProjects, GQL_currentUnitProjects_currentUnit_projects } from '@/queries/__generated__/currentUnitProjects';
import { ALL_PROJECTS } from '@/queries/Project';
import { GQL_currentUnitDepartments, GQL_currentUnitDepartments_currentUnit_departments } from '@/queries/__generated__/currentUnitDepartments';
import { ALL_DEPARTMENTS } from '@/queries/Department';
import MainPaycheckLineTemplateOverwriteEntity from './MainPaycheckLineTemplateOverwriteEntity.vue';
import { GQL_currentUnitCars_currentUnit_cars, GQL_currentUnitCars } from '@/queries/__generated__/currentUnitCars';
import { ALL_CARS } from '@/queries/Car';
import cloneDeep from 'lodash/cloneDeep';
import {
  SAVE_MAIN_PAYCHECK_LINE_TEMPLATE, UNIT_MAIN_PAYCHECK_LINE_TEMPLATES,
  mainPaycheckLineTemplateFormFragment,
} from '@/queries/MainPaycheckLineTemplate';
import SForm from '@/components/UI/Form/SForm.vue';
import { GQL_allMainPaycheckLineTemplates } from '@/queries/__generated__/allMainPaycheckLineTemplates';
import { GQL_unitMainPaycheckLineTemplates } from '@/queries/__generated__/unitMainPaycheckLineTemplates';
import i18n from '@/i18n';
import { sort, sortGetter } from '../UI/Table/sorting';
import gql from 'graphql-tag';

const ALL_MAIN_PAYCHECK_LINE_TEMPLATES = gql`
  query allMainPaycheckLineTemplates {
    mainPaycheckLineTemplates {
      ...mainPaycheckLineTemplateFormFragment
    }
  }
  ${mainPaycheckLineTemplateFormFragment}
`;

interface IReadonlyByDefault {
  $_editable: boolean;
}

type TemplateLine = WithUID<GQL_MainPaycheckLineTemplateSave> & IReadonlyByDefault;

const validateAltinnFields: sValidation = ({ formElements, uid }) => {
  if (
    !formElements.altinnDescription ||
    !formElements.altinnFordel ||
    !formElements.altinnDescription[uid as string] ||
    !formElements.altinnFordel[uid as string]
  ) return true;

  if (
    formElements.altinnDescription[uid as string].dataValue &&
    formElements.altinnDescription[uid as string].dataValue === 'taxDeductionOrdinary'
  ) return true;
  if (
    formElements.altinnDescription[uid as string].dataValue &&
    formElements.altinnDescription[uid as string].dataValue === 'taxDeductionVoluntary'
  ) return true;

  if (
    formElements.altinnDescription[uid as string].dataValue &&
    formElements.altinnDescription[uid as string].dataValue === 'garnishment'
  ) return true;

    if (
      formElements.altinnDescription[uid as string].dataValue &&
      formElements.altinnDescription[uid as string].dataValue === 'garnishmentSamordnet'
    ) return true;

  return !!formElements.altinnDescription[uid as string].dataValue === !!formElements.altinnFordel[uid as string].dataValue;
};

const validateAltinnFieldsOnTaxDeduction: sValidation = ({ dataValue, formElements, uid }) => {
  if (!formElements.taxDeduction || !formElements.taxDeduction[uid as string]) return true;

  return !formElements.taxDeduction[uid as string].dataValue || !dataValue;
};

const validateAltinnFieldsOnGarnishment: sValidation = ({ dataValue, formElements, uid }) => {
  if (!formElements.garnishment || !formElements.garnishment[uid as string]) return true;

  return !formElements.garnishment[uid as string].dataValue || !dataValue;
};

const validateAltinnFieldsOnGarnishmentSamordnet: sValidation = ({ dataValue, formElements, uid }) => {
  if (!formElements.garnishmentSamordnet || !formElements.garnishmentSamordnet[uid as string]) return true;

  return !formElements.garnishmentSamordnet[uid as string].dataValue || !dataValue;
};

@Component({
  components: {
    MainPaycheckLineTemplateOverwriteEntity,
  },
})
export default class MainPaycheckLineTemplateForm extends Vue {
  @SmartQuery(CURRENT_UNIT) private currentUnit!: GQL_currentUnit_currentUnit;

  @SmartQuery<MainPaycheckLineTemplateForm, GQL_currentUnitCars>({
    query: ALL_CARS,
    update: data => data.currentUnit.cars,
    skip() { return this.isGlobalTemplate },
  }) private cars?: GQL_currentUnitCars_currentUnit_cars[];

  @SmartQuery<MainPaycheckLineTemplateForm, GQL_currentUnitProjects>({
    query: ALL_PROJECTS,
    update: data => data.currentUnit.projects,
    skip() { return this.isGlobalTemplate },
  }) private projects?: GQL_currentUnitProjects_currentUnit_projects[];

  @SmartQuery<MainPaycheckLineTemplateForm, GQL_currentUnitDepartments>({
    query: ALL_DEPARTMENTS,
    update: data => data.currentUnit.departments,
    skip() { return this.isGlobalTemplate },
  }) private departments?: GQL_currentUnitDepartments_currentUnit_departments[];

  @SmartQuery<MainPaycheckLineTemplateForm, GQL_allMainPaycheckLineTemplates | GQL_unitMainPaycheckLineTemplates>({
    query() { return this.isGlobalTemplate ? ALL_MAIN_PAYCHECK_LINE_TEMPLATES : UNIT_MAIN_PAYCHECK_LINE_TEMPLATES },
    fetchPolicy: 'network-only', // TODO: Should be cached query. Implement correct updating of cache after mutation.
    update(data) {
      if (this.isGlobalTemplate) {
        return convertToMainPaycheckLineTemplateSave((data as GQL_allMainPaycheckLineTemplates).mainPaycheckLineTemplates);
      } else {
        return convertToMainPaycheckLineTemplateSave((data as GQL_unitMainPaycheckLineTemplates).currentUnit.mainPaycheckLineTemplates);
      }
    },
    result() {
      this.manuallySort(this.sortColumn, this.sortDirecton);
      // mainPaycheckLineTemplates is not updated when resetFormDirty is called but one tick after
      this.$nextTick(() => {
        this.resetFormDirty();
      });
    },
  }) private mainPaycheckLineTemplates!: TemplateLine[];

  private SAVE_MAIN_PAYCHECK_LINE_TEMPLATE = SAVE_MAIN_PAYCHECK_LINE_TEMPLATE;
  private UNIT_MAIN_PAYCHECK_LINE_TEMPLATES = UNIT_MAIN_PAYCHECK_LINE_TEMPLATES;
  private ALL_MAIN_PAYCHECK_LINE_TEMPLATES = ALL_MAIN_PAYCHECK_LINE_TEMPLATES;

  @Prop({ type: Boolean, default: false }) private isGlobalTemplate!: boolean;
  @Prop({ type: Boolean, default: false }) private editable!: boolean;

  private calculationTypes = Object.keys(GQL_PaycheckLineCalculationTypeEnum);
  private altinnFordels = Object.keys(GQL_AltinnFordelEnum);
  private altinnDescriptions =
    Object.keys(GQL_AltinnIncomeDescriptionEnum)
      .concat([ 'taxDeductionOrdinary','taxDeductionVoluntary', 'garnishment', 'garnishmentSamordnet' ]);

  private validForm = true;
  @PropSync('dirty', { type: Boolean, default: false }) private dirtyForm!: boolean;

  @Ref() private readonly formRef?: SForm;

  private rules: IRules = {
    number: [
      { validation: validateRequired(), message: i18n => i18n.t('Error.required', { field: this.t_attr('MainPaycheckLineTemplate', 'number') }) },
      { validation: validateType('number'), message: i18n => i18n.t('GQL.Type.uint') },
    ],
    description: [ { validation: validateRequired(), message: i18n => i18n.t('Error.required', { field:  this.t_attr('MainPaycheckLineTemplate', 'description') }) } ],
    altinnDescription: [
      {
        validation: validateAltinnFields,
        message: i18n => i18n.t('MainPaycheckLineTemplate.bothOrNoneAltinnFields'),
        triggerBy: [ ({ withSameUID }) => withSameUID('altinnFordel') ],
      },
      {
        validation: ({ formElements, uid}) => {
          if (!formElements.taxDeduction?.[uid as string].dataValue) return true;

          if (formElements.taxable?.[uid as string]?.dataValue) return false;
          if (formElements.employerTaxable?.[uid as string]?.dataValue) return false;
          if (formElements.includeInVacationMoneyBase?.[uid as string]?.dataValue) return false;
          if (formElements.garnishment?.[uid as string]?.dataValue) return false;
          if (formElements.garnishmentSamordnet?.[uid as string]?.dataValue) return false;
          if (formElements.vacationMoneyEarnedInPreviousYear?.[uid as string]?.dataValue) return false;
          if (formElements.vacationMoneyEarnedInCurrentYear?.[uid as string]?.dataValue) return false;

          return true;
        },
        message: i18n => i18n.t('MainPaycheckLineTemplate.combinationinvalid'),
        triggerBy: [
          ({ withSameUID }) => withSameUID('taxable'),
          ({ withSameUID }) => withSameUID('employerTaxable'),
          ({ withSameUID }) => withSameUID('includeInVacationMoneyBase'),
          ({ withSameUID }) => withSameUID('garnishment'),
          ({ withSameUID }) => withSameUID('garnishmentSamordnet'),
          ({ withSameUID }) => withSameUID('vacationMoneyEarnedInPreviousYear'),
          ({ withSameUID }) => withSameUID('vacationMoneyEarnedInCurrentYear'),
        ],
      },
      {
        validation: ({ formElements, uid}) => {
          if (!formElements.garnishment?.[uid as string].dataValue) return true;
          if (!formElements.garnishmentSamordnet?.[uid as string].dataValue) return true;

          if (formElements.taxable?.[uid as string]?.dataValue) return false;
          if (formElements.employerTaxable?.[uid as string]?.dataValue) return false;
          if (formElements.includeInVacationMoneyBase?.[uid as string]?.dataValue) return false;
          if (formElements.taxDeduction?.[uid as string]?.dataValue) return false;
          if (formElements.vacationMoneyEarnedInPreviousYear?.[uid as string]?.dataValue) return false;
          if (formElements.vacationMoneyEarnedInCurrentYear?.[uid as string]?.dataValue) return false;

          return true;
        },
        message: i18n => i18n.t('MainPaycheckLineTemplate.combinationinvalid'),
        triggerBy: [
          ({ withSameUID }) => withSameUID('taxable'),
          ({ withSameUID }) => withSameUID('employerTaxable'),
          ({ withSameUID }) => withSameUID('includeInVacationMoneyBase'),
          ({ withSameUID }) => withSameUID('taxDeduction'),
          ({ withSameUID }) => withSameUID('vacationMoneyEarnedInPreviousYear'),
          ({ withSameUID }) => withSameUID('vacationMoneyEarnedInCurrentYear'),
        ],
      },
    ],
    altinnFordel: [
      {
        validation: validateAltinnFields,
        message: i18n => i18n.t('MainPaycheckLineTemplate.bothOrNoneAltinnFields'),
        triggerBy: [ ({ withSameUID }) => withSameUID('altinnDescription') ],
      },
      {
        validation: validateAltinnFieldsOnTaxDeduction,
        message: i18n => i18n.t('MainPaycheckLineTemplate.cannotSelectIfTaxDeduction'),
        triggerBy: [ ({ withSameUID }) => withSameUID('taxDeduction') ],
      },
      {
        validation: validateAltinnFieldsOnGarnishment,
        message: i18n => i18n.t('MainPaycheckLineTemplate.cannotSelectIfGarnishment'),
        triggerBy: [ ({ withSameUID }) => withSameUID('garnishment') ],
      },
      {
        validation: validateAltinnFieldsOnGarnishmentSamordnet,
        message: i18n => i18n.t('MainPaycheckLineTemplate.cannotSelectIfGarnishment'),
        triggerBy: [ ({ withSameUID }) => withSameUID('garnishmentSamordnet') ],
      },
    ],
    quantity: [ { validation: validateType('number'), message: i18n => i18n.t('Error.required', { field:  this.t_attr('MainPaycheckLineTemplate', 'quantity') }) } ],
    rate: [ { validation: validateType('number'), message: i18n => i18n.t('Error.required', { field:  this.t_attr('MainPaycheckLineTemplate', 'rate') }) } ],
    sum: [
      { validation: validateType('number'), message: i18n => i18n.t('Error.required', { field:  this.t_attr('MainPaycheckLineTemplate', 'sum') }) },
      {
        validation: ({ dataValue, formElements, uid }) => {
          if (
            !formElements.rate ||
            !formElements.rate[uid as string] ||
            !formElements.quantity ||
            !formElements.quantity[uid as string]
          ) return true;

          if (
            formElements.rate[uid as string].dataValue.isZero() &&
              formElements.quantity[uid as string].dataValue.isZero()
          ) return true;

          return (
            formElements.quantity[uid as string].dataValue
              .times(formElements.rate[uid as string].dataValue)
              .toDecimalPlaces(2)
              .equals(dataValue)
          );
        },
        message: i18n => i18n.t('MainPaycheckLineTemplate.sumError'),
        triggerBy: [
          ({ withSameUID }) => withSameUID('rate'),
          ({ withSameUID }) => withSameUID('quantity'),
        ],
        type: 'warning',
      },
    ],
    taxDeduction: [], // Used for triggerBy for altinnFordel
    garnishment: [], // Used for triggerBy for altinnFordel
    garnishmentSamordnet: [], // Used for triggerBy for altinnFordel
    taxable: [
      {
        validation: ({ dataValue, formElements, uid }) => {
          if (!dataValue) return true;
          if (formElements.taxDeduction?.[uid as string]?.dataValue) return false;
          if (formElements.garnishment?.[uid as string]?.dataValue) return false;
          if (formElements.garnishmentSamordnet?.[uid as string]?.dataValue) return false;

          return true;
        },
        message: i18n => i18n.t('MainPaycheckLineTemplate.combinationinvalid'),
        triggerBy: [
          ({ withSameUID }) => withSameUID('taxDeduction'),
          ({ withSameUID }) => withSameUID('garnishment'),
          ({ withSameUID }) => withSameUID('garnishmentSamordnet'),
        ],
      },
    ],
    employerTaxable: [
      {
        validation: ({ dataValue, formElements, uid }) => {
          if (!dataValue) return true;
          if (formElements.taxDeduction?.[uid as string]?.dataValue) return false;
          if (formElements.garnishment?.[uid as string]?.dataValue) return false;
          if (formElements.garnishmentSamordnet?.[uid as string]?.dataValue) return false;

          return true;
        },
        message: i18n => i18n.t('MainPaycheckLineTemplate.combinationinvalid'),
        triggerBy: [
          ({ withSameUID }) => withSameUID('taxDeduction'),
          ({ withSameUID }) => withSameUID('garnishment'),
          ({ withSameUID }) => withSameUID('garnishmentSamordnet'),
        ],
      },
    ],
    includeInVacationMoneyBase: [
      {
        validation: ({ dataValue, formElements, uid }) => {
          if (!dataValue) return true;
          if (formElements.taxDeduction?.[uid as string]?.dataValue) return false;
          if (formElements.garnishment?.[uid as string]?.dataValue) return false;
          if (formElements.garnishmentSamordnet?.[uid as string]?.dataValue) return false;
          if (formElements.vacationMoneyEarnedInPreviousYear?.[uid as string]?.dataValue) return false;
          if (formElements.vacationMoneyEarnedInCurrentYear?.[uid as string]?.dataValue) return false;

          return true;
        },
        message: i18n => i18n.t('MainPaycheckLineTemplate.combinationinvalid'),
        triggerBy: [
          ({ withSameUID }) => withSameUID('taxDeduction'),
          ({ withSameUID }) => withSameUID('garnishment'),
          ({ withSameUID }) => withSameUID('garnishmentSamordnet'),
          ({ withSameUID }) => withSameUID('vacationMoneyEarnedInPreviousYear'),
          ({ withSameUID }) => withSameUID('vacationMoneyEarnedInCurrentYear'),
        ],
      },
    ],
    vacationMoneyEarnedInPreviousYear: [
      {
        validation: ({ dataValue, formElements, uid }) => {
          if (!dataValue) return true;
          if (formElements.includeInVacationMoneyBase?.[uid as string]?.dataValue) return false;
          if (formElements.taxDeduction?.[uid as string]?.dataValue) return false;
          if (formElements.garnishment?.[uid as string]?.dataValue) return false;
          if (formElements.garnishmentSamordnet?.[uid as string]?.dataValue) return false;
          if (formElements.vacationMoneyEarnedInCurrentYear?.[uid as string]?.dataValue) return false;

          return true;
        },
        message: i18n => i18n.t('MainPaycheckLineTemplate.combinationinvalid'),
        triggerBy: [
          ({ withSameUID }) => withSameUID('includeInVacationMoneyBase'),
          ({ withSameUID }) => withSameUID('taxDeduction'),
          ({ withSameUID }) => withSameUID('garnishment'),
          ({ withSameUID }) => withSameUID('garnishmentSamordnet'),
          ({ withSameUID }) => withSameUID('vacationMoneyEarnedInCurrentYear'),
        ],
      },
    ],
    vacationMoneyEarnedInCurrentYear: [
      {
        validation: ({ dataValue, formElements, uid }) => {
          if (!dataValue) return true;
          if (formElements.includeInVacationMoneyBase?.[uid as string]?.dataValue) return false;
          if (formElements.taxDeduction?.[uid as string]?.dataValue) return false;
          if (formElements.garnishment?.[uid as string]?.dataValue) return false;
          if (formElements.garnishmentSamordnet?.[uid as string]?.dataValue) return false;
          if (formElements.vacationMoneyEarnedInPreviousYear?.[uid as string]?.dataValue) return false;

          return true;
        },
        message: i18n => i18n.t('MainPaycheckLineTemplate.combinationinvalid'),
        triggerBy: [
          ({ withSameUID }) => withSameUID('includeInVacationMoneyBase'),
          ({ withSameUID }) => withSameUID('taxDeduction'),
          ({ withSameUID }) => withSameUID('garnishment'),
          ({ withSameUID }) => withSameUID('garnishmentSamordnet'),
          ({ withSameUID }) => withSameUID('vacationMoneyEarnedInPreviousYear'),
        ],
      },
    ],
  };

  @Watch('mainPaycheckLineTemplates', { immediate: true })
  private ensureUIDsAreSet() {
    (this.mainPaycheckLineTemplates || []).forEach(line => {
      if (!line.$_UID) line.$_UID = generateUID();
    });
  }

  private get editableLines(): TemplateLine[] {
    if (!this.mainPaycheckLineTemplates) return [];

    return this.mainPaycheckLineTemplates.filter(line => line.$_editable);
  }

  private makeAllEditable() {
    this.mainPaycheckLineTemplates.forEach(line => {
      if (line.$_editable) return;

      this.makeEditable(line);
    });
  }

  private makeEditable(line: TemplateLine) {
    this.$set(line, '$_editable', true);
  }

  private mainPaycheckLineTemplateSaved() {
    this.manuallySort(this.sortColumn, this.sortDirecton);
    this.$sMessage.success(this.$t('MainPaycheckLineTemplate.saveSuccess'));
  }

  private addMainPayCheckLineTemplate() {
    this.mainPaycheckLineTemplates.push(
      {
        ...newMainPaycheckLineTemplateObject(),
        $_editable: true,
        $_UID: generateUID(),
      },
    );
  }

  private duplicateMainPaycheckLineTemplate(line: TemplateLine) {
    const duplicatedTemplate = cloneDeep(line);
    duplicatedTemplate.id = null;
    duplicatedTemplate.$_UID = generateUID();
    this.mainPaycheckLineTemplates.splice(
      this.mainPaycheckLineTemplates.indexOf(line) + 1, 0, duplicatedTemplate,
    );
  }

  public get formatDataForMutation() {
    return {
      unitId: this.isGlobalTemplate ? null : this.currentUnit.id,
      mainPaycheckLineTemplates: this.mainPaycheckLineTemplates.map(line => ({
        ...line,
        $_UID: undefined,
        $_editable: undefined,
      })),
    };
  }

  private resetFormDirty() {
    this.formRef && this.formRef.resetDirty();
  }

  private sortColumn = 'number';
  private sortDirecton = 'asc';

  private manuallySort(column: string, direction: string) {
    this.sortColumn = column;
    this.sortDirecton = direction;

    let getter: sortGetter<TemplateLine> = column;

    if (column === 'altinnDescription') {
      getter = this.printAltinnDescription;
    }
    if (column === 'altinnFordel') {
      getter = this.printAltinnFordel;
    }

    this.mainPaycheckLineTemplates = sort(this.mainPaycheckLineTemplates, getter, direction);
  }

  private printAltinnFordel(line: TemplateLine) {
    return line.altinnFordel ? this.$t(`Altinn.Fordels.${line.altinnFordel}`) as string : '';
  }

  private get carsForSelect() {
    return !this.isGlobalTemplate && this.cars ? this.cars : [];
  }

  private get projectsForSelect() {
    return !this.isGlobalTemplate && this.projects ? this.projects : [];
  }

  private get departmentsForSelect() {
    return !this.isGlobalTemplate && this.departments ? this.departments : [];
  }

  public saveAndContinue() {
    if (!this.editable) return false;

    return this.$apollo.mutate({
      mutation: SAVE_MAIN_PAYCHECK_LINE_TEMPLATE,
      variables: this.formatDataForMutation,
    }).then(() => {
      // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
      this.$sMessage.success(i18n.t('Message.saveSuccess'));
      return true;
    }).catch(() => {
      // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
      return false;
    });
  }

  private getCustomAltinnDescription(line: TemplateLine): GQL_AltinnIncomeDescriptionEnum | string | null {
    if (line.taxDeductionVoluntary) return 'taxDeductionVoluntary';
    if (line.taxDeduction) return 'taxDeductionOrdinary';
    if (line.garnishment) return 'garnishment';
    if (line.garnishmentSamordnet) return 'garnishmentSamordnet';
    return line.altinnDescription || null;
  }

  private setCustomAltinnDescription(line: TemplateLine, value: GQL_AltinnIncomeDescriptionEnum | 'taxDeductionOrdinary'  | 'taxDeductionVoluntary' | 'garnishment' | 'garnishmentSamordnet' | null): void {
    line.taxDeduction = false;
    line.taxDeductionVoluntary = false;
    line.garnishment = false;
    line.garnishmentSamordnet = false;
    line.altinnDescription = null;

    if (value === 'taxDeductionOrdinary') {
      line.taxDeduction = true;
    } else if (value === 'taxDeductionVoluntary') {
      line.taxDeduction = true;
      line.taxDeductionVoluntary = true;
    } else if (value === 'garnishment') {
      line.garnishment = true;
    } else if (value === 'garnishmentSamordnet') {
      line.garnishmentSamordnet = true;
    } else {
      line.altinnDescription = value || null;
    }
  }

  private printAltinnDescription(item: TemplateLine): string {
    if (item.taxDeductionVoluntary) return this.$t(`MainPaycheckLineTemplate.taxDeductionVoluntary`) as string;
    if (item.taxDeduction) return this.$t(`MainPaycheckLineTemplate.taxDeduction`) as string;
    if (item.garnishment) return this.$t(`MainPaycheckLineTemplate.garnishment`) as string;
    if (item.garnishmentSamordnet) return this.$t(`MainPaycheckLineTemplate.garnishmentSamordnet`) as string;
    if (item.altinnDescription) return this.$t(`Altinn.IncomeDescriptions.${item.altinnDescription}`) as string;
    return '';
  }

  private printCar(car: GQL_currentUnitCars_currentUnit_cars): string {
    return `${car.registrationNumber} - ${car.name}`;
  }
}
